import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { AllergenIcon } from 'components/Icons';

const propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

const AllergenThemedIcon = ({ className, width, height }) => (
  <AllergenIcon className={className} width={width} height={height} />
);

AllergenThemedIcon.propTypes = propTypes;

export default withTheme(AllergenThemedIcon);
